import { Component, ViewChild } from '@angular/core';

import { MenuController, NavController, Slides } from 'ionic-angular';

import { Storage } from '@ionic/storage';

import { TabsPage } from '../tabs-page/tabs-page';
import {UserData} from "../../providers/user-data";
import {UiData} from "../../providers/ui-data";

@Component({
    selector: 'page-tutorial',
    templateUrl: 'tutorial.html'
})

export class TutorialPage {

    public static readonly pageName = "TutorialPage";
    showSkip = true;
    isLoggedIn = false;

    @ViewChild('slides') slides: Slides;

    constructor(
        public navCtrl: NavController,
        public menu: MenuController,
        public storage: Storage,
        public userData: UserData,
        public uiData: UiData
    ) { }

    startApp() {
      if(this.isLoggedIn)
      {
          this.menu.enable(true);

          this.menu.enable(true, 'loggedInMenu');
          this.menu.enable(false, 'loggedOutMenu');

          this.navCtrl.setRoot('MissionsListPage').then(() => {
              this.storage.set('hasSeenTutorial', 'true');
          })
      }
      else
      {
          this.menu.enable(false);
          this.navCtrl.setRoot('SignupPage').then(() => {
              this.storage.set('hasSeenTutorial', 'true');
          })
      }
    }
    startAppLogin() {
        this.navCtrl.setRoot('LoginPage').then(() => {
            this.storage.set('hasSeenTutorial', 'true');
        })
    }
    startAppSignup() {
        this.navCtrl.setRoot('SignupPage').then(() => {
            this.storage.set('hasSeenTutorial', 'true');
        })
    }

    onSlideChangeStart(slider: Slides) {
        this.showSkip = !slider.isEnd();
    }

    onSlideChangeEnd(slider: Slides) {
        if(slider.isEnd())
        {
            this.startAppLogin();
        }
    }
    ionViewWillEnter() {
        this.slides.update();
        var that = this;
        this.storage.get("hasLoggedIn").then((value) => {
            that.isLoggedIn= value;
        });
        if(this.uiData.isWebVersion())
        {
            if(this.isLoggedIn)
            {
                this.startApp();
            }
            else
            {
                this.startAppLogin();
            }
        }
    }

    ionViewDidEnter() {
        // the root left menu should be disabled on the tutorial page
        this.menu.enable(false);
    }

    ionViewDidLeave() {
        // enable the root left menu when leaving the tutorial page
        this.menu.enable(true);
    }
    next()
    {
        let currentIndex = this.slides.getActiveIndex();

        this.slides.slideTo(currentIndex+1,500);
    }

}



// WEBPACK FOOTER //
// ./src/pages/tutorial/tutorial.ts